import React, { useEffect } from 'react';
import useProps from '../_util/useProps';
import { registerEventLayer } from '../events';
import WallGeometry from './WallGeometry';

export default function(props) {
    const { map } = useProps();

    useEffect(() => {
        const primitive = new WallGeometry(props);
        registerEventLayer(primitive, props);
        map.scene.primitives.add(primitive);
        return () => {
            map.scene.primitives.remove(primitive);
        };
    }, []);

    return <></>;
}
